// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__eWwbT","legacyBtn":"MutateMid_legacyBtn__3ObYZ"};